<template>
  <div class="avatar">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
};
</script>

<style scoped lang="stylus">
  .avatar
    background rgb(28,65,140)
    height 36px
    width 36px
    border-radius 50%
    text-align center
    line-height 36px
    font-weight bold
    color white
</style>
